// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let MarkupHelpers = require("../../../common/MarkupHelpers/MarkupHelpers.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let LogoMobileSvg = require("../../../../../assets/images/logos/logo-mobile.svg");
let LogoDesktopSvg = require("../../../../../assets/images/logos/logo-desktop.svg");

let logoDesktop = LogoDesktopSvg;

let logoTablet = LogoMobileSvg;

function Sharing__ClientPageHeader(props) {
  return JsxRuntime.jsx("header", {
    children: JsxRuntime.jsx(MarkupHelpers.Container.make, {
      children: JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("a", {
          children: JsxRuntime.jsxs("picture", {
            children: [
              JsxRuntime.jsx("source", {
                media: "(min-width: 992px)",
                srcSet: logoDesktop
              }),
              JsxRuntime.jsx("img", {
                alt: "logo",
                src: logoTablet
              })
            ]
          }),
          href: "/"
        }),
        className: "items-center flex justify-between h-[67px]"
      })
    }),
    className: "bg-white border-b border-zinc-300"
  });
}

let make = Sharing__ClientPageHeader;

exports.logoDesktop = logoDesktop;
exports.logoTablet = logoTablet;
exports.make = make;
/* logoDesktop Not a pure module */
